import $ from "jquery";
import CONFIG from "@bd-core/config";
import { getHintUsed } from "@bd-stores/game-progress";
import { updateHintUsed } from "@bd-core/firebase-actions";

export default class Hints {
    constructor() {
        this.elms = {
            hintsContainer: ".hints-container",
            hints: ".hints",
            hintsInner: ".hints__inner",
            popupQuestion: ".hints__popup.question",
            popupHint: ".hints__popup.hint",
            hintTitle: ".hints__popup-title",
            hintContent: ".hints__popup-content",
            hintButtonNo: ".hints__popup-button.btn--secondary",
            hintButtonYes: ".hints__popup-button.btn--primary",
        };

        this.roomId = false;
        this.popupHint = [];
        this.isHintUsed = false;

        return this;
    }

    init(roomId, popupHint) {
        this.roomId = roomId;
        this.popupHint = popupHint;
        this.isHintUsed = getHintUsed(roomId);

        const elms = this.elms;
        const hintProps = CONFIG.game.hintProp.hint_popup;
        const hintAnswer = this.popupHint[0];

        const $popupQuestion = $(elms.popupQuestion);
        const $popupHint = $(elms.popupHint);

        $popupQuestion.find(elms.hintTitle).text(hintProps.title);
        $popupQuestion.find(elms.hintContent).html(hintProps.confirmation_text);
        $popupQuestion.find(elms.hintButtonNo).find("span").text(hintProps.cancel_button_text);
        $popupQuestion.find(elms.hintButtonYes).find("span").text(hintProps.confirm_button_text);

        $popupHint.find(elms.hintContent).html(hintAnswer?.text || "Hint");

        if (!this.initialized) this.registerEvents();
    }

    registerEvents() {
        const $document = $(document);
        // Remove previously registered event listeners to avoid duplicates
        $document.off("click", this.elms.hintsInner);
        $document.off("click", this.elms.hintButtonNo);
        $document.off("click", this.elms.hintButtonYes);

        $document.on(
            "click",
            this.elms.hintsInner,
            this.toggleHints.bind(this),
        );
        $document.on(
            "click",
            this.elms.hintButtonNo,
            this.onClickedHintNo.bind(this),
        );
        $document.on(
            "click",
            this.elms.hintButtonYes,
            this.onClickedHintYes.bind(this),
        );

        this.initialized = true;
    }

    toggleHints() {
        const $hints = $(this.elms.hints);

        const isHintUsed = this.isHintUsed;

        if (isHintUsed) {
            $hints.toggleClass("is-open show-hint");
        } else {
            $hints.toggleClass("is-open");
        }
    }

    onClickedHintNo() {
        const $hints = $(this.elms.hints);
        $hints.removeClass("is-open");
    }

    onClickedHintYes() {
        if (this.isHintUsed) return;

        updateHintUsed(this.roomId, true).then(() => {
            this.isHintUsed = true;
            const $hints = $(this.elms.hints);
            $hints.addClass("show-hint");
        });
    }
}
